import React from 'react' 

export default (props) => (
  <div className='text-left'>
    <button type='button' className='btn btn-success' onClick={props.handleSave}>Save</button>
  </div>
)
